import React from 'react';
import { Flex, Text, Link, ToolkitFeatureFlag, Skeleton, SkeletonText } from '@cko/primitives';
import styled from 'styled-components';
import { ExternalLinkUrl } from 'config/shared/types/links';
import settings from '../../../../../services/app-settings';

/*
type PropsWithOptionalChildren = { children?: React.ReactNode };

type ExtractProps<T> = (T extends ComponentType<infer P> ? P : T) & PropsWithOptionalChildren;

type TextStatusProps = Pick<ExtractProps<typeof TextStatus>, 'variant'>;
*/

type DescriptionProps = {
  descriptionText?: string;
  dynamicDescriptionEnabled?: boolean;
  dynamicDescription?: string;
  documentation?: {
    text: string;
    url: ExternalLinkUrl;
  };
};

const DescriptionText = styled(Text)`
  font: var(--body-xs);
  color: var(--base-text);
`;

const Container = styled(Flex)`
  align-items: center;
  gap: var(--layout-seed);
  align-self: stretch;
`;

const env = settings.app.env as keyof ExternalLinkUrl;

const resolveLink = (url: ExternalLinkUrl) => {
  return url[env] || url.default || '';
};

export const Description = ({
  descriptionText,
  dynamicDescriptionEnabled,
  dynamicDescription,
  documentation,
}: DescriptionProps) => {
  return (
    <Container>
      {!dynamicDescriptionEnabled && descriptionText && (
        <DescriptionText>{descriptionText}</DescriptionText>
      )}
      {dynamicDescriptionEnabled && !dynamicDescription && (
        <Skeleton
          style={{
            width: '150px',
          }}
        >
          <SkeletonText />
        </Skeleton>
      )}
      {dynamicDescriptionEnabled && dynamicDescription && (
        <DescriptionText>{dynamicDescription}</DescriptionText>
      )}
      {documentation && (
        <ToolkitFeatureFlag flag="v10">
          <Link href={resolveLink(documentation.url)} variant="external">
            {documentation.text}
          </Link>
        </ToolkitFeatureFlag>
      )}
    </Container>
  );
};
